import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import BlacklistActions from './blacklist-actions';

const initialState = Immutable({
  blacklistDictionary: '',
});

const reducer = createReducer(on => {
  on(BlacklistActions.updateBlacklist, (state, { blacklistDictionary }) => {
    return state.set('blacklistDictionary', blacklistDictionary);
  });

  on(BlacklistActions.saveBlacklistSuccess, (state, { blacklistDictionary }) => {
    return state.set('blacklistDictionary', blacklistDictionary);
  });
}, initialState);

export default reducer;
